import { createSlice, PayloadAction, Dispatch } from "@reduxjs/toolkit";
import { ProspectInfoChoices } from "interfaces/metadata";
import { getServicesManager } from "../../../../services";

export interface ProspectInfoOptionsState { value: ProspectInfoChoices | null }
const dispositionOptionsInitialResult: ProspectInfoOptionsState = { value: null }

export const dispositionOptionSlice = createSlice({
  name: 'dispositionOptions',
  initialState: dispositionOptionsInitialResult,
  reducers: {
    updateDispositionOptions: (state, action: PayloadAction<ProspectInfoChoices>) => {
      state.value = action.payload;
    },
  }
});

export function reloadDispositionOptions(dispatch: Dispatch): Promise<ProspectInfoChoices | null> {
  const result = getServicesManager().getDispositions();
  result.then(v => {
    if (v !== null) {
      dispatch((dispositionOptionSlice.actions.updateDispositionOptions(v)));
    }
  });
  return result;
}
const prospectInfoOptionsInitialResult: ProspectInfoOptionsState = {
  value: null,
};

export const prospectInfoOptionSlice = createSlice({
  name: 'prospectInfoOptions',
  initialState: prospectInfoOptionsInitialResult,
  reducers: {
    updateProspectInfoOptions: (state, action: PayloadAction<ProspectInfoChoices>) => {
      state.value = action.payload;
    },
  }
});

export function reloadProspectInfoOptions(dispatch: Dispatch): Promise<ProspectInfoChoices | null> {
  const result = getServicesManager().getProspectInfo();
  result.then(v => {
    if (v !== null) {
      dispatch((prospectInfoOptionSlice.actions.updateProspectInfoOptions(v)));
    }
  });
  return result;
}
